import axioPath from "api/axioPath";
import { UPDATE_DATA } from "redux/actions/action_types";

export const emailOtp = (data) => (dispatch) => {
  return axioPath
    .post("/auth/otp", data)
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (typeof ex == "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};

export const otpVerification = (data) => (dispatch) => {
  return axioPath
    .post("/auth/verify_opt", data)
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (typeof ex == "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};